const explicitFlag = process.env.VUE_APP_PUBLIC_CONTENT_ENABLED;
export const PUBLIC_CONTENT_ENABLED = process.env.NODE_ENV === "production"
  ? String(explicitFlag).toLowerCase() === "true"
  : String(explicitFlag ?? "true").toLowerCase() !== "false";
